import { shopNewestListings as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  newestListingsHeader: 'Newest Listings',
  shopIds: 'OC05847',
  showNewestListings: true,
};

export default fakeProps(schema, TestData);
